import { CommonLayout } from '../../../commonComponents';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, Route, Switch, useHistory, useRouteMatch, Router } from 'react-router';
import { Location } from 'history';
import { RootStateType } from '../../../../redux-store/reducers';
import { USER_ROLES } from '../../../../utils/constant';
import { InvestorManagementLayout, MenuItemListLink } from '../../InvestorManagementLayout';
import DistributorDetailsNCT from './distributorDetails';
import ContributorDetailsNCT from './contributorDetails';
import ContactDetailsNCT from './contactDetails';
import AdditionalKYCDetailsNCT from './additionalKYCDetails';
import FatcaNCT from './fatca';
import NomineeDetailsNCT from './nomineeDetails';
import BankDetailsNCT from './bankDetails';
import InvestmentPaymentDetailsNCT from './investmentPaymentDetails';
import DocumentDetailsNCT from './documentDetails';
import { getNctApplicationDetails } from '../../../../redux-store/actions/nct';
import { ApplicationNctProps } from '../../../../redux-store/types/nct';

export const Routes = ({
  id,
  applicant1ReferenceId,
}: {
  id: string;
  applicant1ReferenceId?: string;
  applicationType?: string;
}): JSX.Element => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { path } = useRouteMatch();

  const {
    auth: { role },
    nctApplication: { application: _application },
    investor: { token = '' },
  } = useSelector((store: RootStateType) => store);

  const { applicationNumber } = _application || {};

  useEffect(() => {
    async function fetchApplication() {
      try {
        if (role === USER_ROLES.INVESTOR && !token) {
          history.push(`/investment-details/${applicant1ReferenceId}/application-details`);
          return;
        }
        if (id) {
          (await dispatch(getNctApplicationDetails(id))) as unknown as ApplicationNctProps;
        } else {
          history.push('/');
          console.error('No application id found');
        }
      } catch (e) {
        console.error((e as Error).message);
      }
    }
    // if (application === null) {
    fetchApplication();
    // }
  }, []);

  return (
    <InvestorManagementLayout
      applicationId={id}
      applicant1ReferenceId={applicant1ReferenceId}
      applicationNumber={applicationNumber || ''}>
      <Router history={history}>
        <Switch>
          <Route
            exact
            path={path}
            render={() => (
              <Redirect
                to={{
                  pathname: `${path}/${MenuItemListLink[0]}`,
                  state: { id, applicant1ReferenceId },
                }}
                from={location.pathname}
              />
            )}
          />
          <Route path={`${path}/distributor-details`} component={DistributorDetailsNCT} />
          <Route path={`${path}/contributor-details`} component={ContributorDetailsNCT} />
          <Route path={`${path}/contact-details`} component={ContactDetailsNCT} />
          <Route path={`${path}/additional-KYC-details`} component={AdditionalKYCDetailsNCT} />
          <Route path={`${path}/fatca`} component={FatcaNCT} />
          <Route path={`${path}/nominee-details`} component={NomineeDetailsNCT} />
          <Route path={`${path}/bank-details`} component={BankDetailsNCT} />
          <Route
            path={`${path}/investment-payment-details`}
            component={InvestmentPaymentDetailsNCT}
          />
          <Route path={`${path}/document-details`} component={DocumentDetailsNCT} />
        </Switch>
      </Router>
    </InvestorManagementLayout>
  );
};

const IndividualKycUpdateRoutes = ({
  location,
}: {
  location: Location<{ id: string; applicant1ReferenceId?: string; applicationType?: string }>;
}): JSX.Element => {
  const { id = '', applicant1ReferenceId = '', applicationType = '' } = location.state || {};
  return (
    <CommonLayout>
      <Routes
        id={id}
        applicant1ReferenceId={applicant1ReferenceId}
        applicationType={applicationType}
      />
    </CommonLayout>
  );
};

export default IndividualKycUpdateRoutes;
